export default __webpack_public_path__ + "4b3b5b728b4ae72ddbd02a6c12fa4dc0.png";